import { cn } from "../../../lib";
import {
	GLASS_BORDER_TONE_SYSTEM_SHELL_BORDER_CLASS,
} from "../glass-border";

/**
 * Default PiP frosted plate — visible as a thick glass band on light pages
 * (docs / empty narrator) and in dark mode. More opaque than bare tone plates
 * so underlying content does not bleed through as strongly.
 */
export const PIP_GLASS_SHELL_PLATE_CLASS = cn(
	"bg-black/[0.08] shadow-xs",
	"dark:bg-white/25",
);

/**
 * PiP plate for dark stages (Ask Live video / audio chrome) — light frosted rim.
 * @deprecated Prefer {@link PIP_GLASS_SHELL_PLATE_CLASS_ON_DARK}.
 */
export const PIP_GLASS_SHELL_PLATE_CLASS_ON_DARK = cn(
	"bg-white/80 shadow-xs",
	"dark:bg-zinc-950/88",
);

/** @deprecated Alias of {@link PIP_GLASS_SHELL_PLATE_CLASS_ON_DARK} for Ask Live imports. */
export const PIP_GLASS_SHELL_PLATE_CLASS_LIGHT = PIP_GLASS_SHELL_PLATE_CLASS_ON_DARK;

/** Default shell hairline — readable on light and dark page bands. */
export const PIP_GLASS_SHELL_SHELL_BORDER_CLASS =
	GLASS_BORDER_TONE_SYSTEM_SHELL_BORDER_CLASS;

/** Shell hairline for dark stages (Ask Live). */
export const PIP_GLASS_SHELL_SHELL_BORDER_CLASS_ON_DARK = cn(
	"border border-white/45",
	"dark:border-white/22",
);
